module.exports = __webpack_public_path__ + "images/emoji/ox.d1e75fe7779668d12c5a.png";